export default __webpack_public_path__ + "abce034722a4e4f0b913ea6a6533f492.svg";